import React from 'react';
import LocationField, { LocationFieldProps } from 'components/styleguide/location_field/LocationField';
import EorTooltip from 'components/post_a_job/eor_tooltip/EorTooltip';

const EorLocationField: React.FC<Omit<LocationFieldProps, 'labelSuffix'>> = (props) => (
  <LocationField {...props} labelSuffix={<EorTooltip />} />
);

export default EorLocationField;
